import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {IonicTokenService, AuthInterceptor, ResponseInterceptor} from '@fitpass/ionic-token-auth';
import {VersionService} from './../services/version';

import io from 'socket.io-client';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    IonicTokenService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor, // to insert auth HTTP headers into requests
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseInterceptor, // to read auth HTTP headers from responses
      multi: true
    }
  ]
})
export class BackendModule {
  productionWhiteList = ['fitpass.app', 'chile.fitpass.app', 'peru.fitpass.app', 'colombia.fitpass.app'];

  production: boolean = this.productionWhiteList.indexOf(window.location.hostname) >= 0;

  backendURL = this.production
    ? 'https://app-backend.fitpass.mx'
    : 'https://app-staging.fitpass.mx';

  socketURL = this.production
    ? 'https://ws-backend.fitpass.mx'
    : 'https://ws-staging.fitpass.mx';

  mapBoxToken = 'pk.eyJ1IjoiZml0cGFzc2RldiIsImEiOiJjbDZrdm5ocjYwNXR6M25tZXFpaXpqeHp1In0.lqwLWABekqny-MUa6TVKJA';


  backendAPIPath = 'api/v3';

  constructor(
    private tokenService: IonicTokenService,
    public versionService: VersionService
  ) {
    this.initTokenService();
  }

  signIn(params) {
    return this.tokenService.signIn(params); // an Observable<Object>
  }

  signOut() {
    return this.tokenService.signOut();
  }

  // Get data from a backend path
  get(path: string, options?: object) {
    return this.tokenService.http.get(`${this.backendURL}/${path}`, this.addHeaders(options));
  }

  // Get data from a backend API subpath (the '/api/v3/' is prepended)
  getAPI(subpath: string, options?: object) {
    return this.get(`${this.backendAPIPath}/${subpath}`, options);
  }

  // Post some data to a backend path
  post(path: string, data: object, options?: object) {
    return this.tokenService.http.post(
      `${this.backendURL}/${path}`,
      data,
      this.addHeaders(options)
    );
  }

  // Post some data to a backend API subpath
  postAPI(subpath: string, data: object, options?: object) {
    return this.post(`${this.backendAPIPath}/${subpath}`, data, options);
  }

  // Put some data to a backend path
  put(path: string, data: object, options?: object) {
    return this.tokenService.http.put(
      `${this.backendURL}/${path}`,
      data,
      this.addHeaders(options)
    );
  }

  // Put some data to a backend API subpath
  putAPI(subpath: string, data: object, options?: object) {
    return this.put(`${this.backendAPIPath}/${subpath}`, data, options);
  }

  // Delete data from a backend path
  delete(path: string, options?: object) {
    return this.tokenService.http.delete(`${this.backendURL}/${path}`, this.addHeaders(options));
  }

  // Delete data from a backend API subpath
  deleteAPI(subpath: string, options?: object) {
    return this.delete(`${this.backendAPIPath}/${subpath}`, options);
  }

  addHeaders(options?: any) {
    options = options || {};
    options.headers = {
      'X-Country': this.versionService.country,
      'X-Version': this.versionService.appVersion
    }
    return options;
  }

  openSocket() {
    return io(this.socketURL);
  }

  initTokenService() {
    this.tokenService.init({
      apiBase: this.backendURL, // overridden
      apiPath: this.backendAPIPath, // overridden

      signInPath: '/auth/sign_in',
      signInRedirect: null,
      signInStoredUrlStorageKey: null,

      signOutPath: 'auth/sign_out',
      validateTokenPath: 'auth/validate_token',
      signOutFailedValidate: false,

      registerAccountPath: 'auth',
      deleteAccountPath: 'auth',
      registerAccountCallback: window.location.href,

      updatePasswordPath: 'auth',
      resetPasswordPath: 'auth/password',
      resetPasswordCallback: window.location.href,

      oAuthBase: window.location.origin,
      oAuthPaths: {
        github: 'auth/github'
      },
      oAuthCallbackPath: 'oauth_callback',
      oAuthWindowType: 'newWindow',
      oAuthWindowOptions: null,

      userTypes: null,

      globalOptions: {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/backend.module.ts